<template>
  <div class="flex flex-col">
    <Header />
    <Linguasnapp />
    <Footer />
  </div>
</template>

<script>
import Footer from './components/footer/Footer';
import Header from './components/header/Header';
import Linguasnapp from './components/linguasnapp/Linguasnapp';


export default {
    name: 'app',
    components: {
        Linguasnapp,
        Footer,
        Header,
    },
};
</script>

<style scoped>

</style>
